import React from "react";

export const ModalSplash =(modalstate)=> {

    return(
        <div> <p>welcome to my site</p><button onClick={modalstate}>Enter</button></div>
    )
};